import { ObjectRepository } from '@framework/repository';
import { GroupEntity } from './GroupEntity';
import type { GroupJSON } from 'balus-common';
import { RTDBPath } from 'balus-common';

type GroupEntityRepository = ObjectRepository<GroupJSON, GroupEntity>;
export const createGroupEntityRepository = (groupId: string): GroupEntityRepository => {
  return new ObjectRepository(GroupEntity, RTDBPath.Group.groupEntityPath(groupId));
};
